/* /client/src/modals/ExchCaptModal/index.js */

import React, { Component } from "react";
//import "./style.css";
import Modal       from "react-bootstrap/Modal";
import Button      from "react-bootstrap/Button";
import ExchCapForm from "../../forms/ExchCapForm";

class ExchCaptModal extends Component {

   render() {
      return (
         <div className="">

            {/* --- Modal window to register new user --- */}
            <Modal show   = {this.props.show}
                   onHide = {this.props.handleCloseDetModal} >

               <Modal.Header closeButton>
                  <Modal.Title>
                     Register each line
                  </Modal.Title>
               </Modal.Header>

               <Modal.Body>
                  <ExchCapForm 
                     handleDetChange = {this.props.handleDetChange} 
                     checkDetailVal  = {this.props.checkDetailVal}
                     state           = {this.props.state.detail}
                  />
               </Modal.Body>

               <Modal.Footer>
                  <Button variant="primary"
                     onClick={this.props.handleDetSubmit}
                  >
                     {this.props.state.detail.action === "Add"  ? "Add"  : ""}
                     {this.props.state.detail.action === "Edit" ? "Save" : ""}
                  </Button>
               </Modal.Footer>
            </Modal>

         </div>
      );
   }
}

export default ExchCaptModal;